<template>
	<div class="_form-field-layout -p-large align-baseline g-row" :data-error="error">
		<div class="line-divider m-t" />
		<div class="g-col xxl-6 md-4 sm-6 xs-5">
			<slot name="index" />
		</div>
		<div class="g-col xxl-10 md-10 sm-18 xs-19">
			<slot name="label" />
		</div>
		<div class="-p-large -align-self-center g-col xxl-8 md-10 sm-18 sm-offset-6 xs-19 xs-offset-5">
			<slot name="input" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		error: { type: Boolean, default: false },
	},
}
</script>

<style lang="scss">
._form-field-layout {
	--form-error-red: #dc3429;
	--color: #{$black};

	position: relative;

	padding-bottom: rs(10, 10);
	margin-bottom: rs(24, 64);

	color: var(--color);

	&[data-error='true'] {
		--color: var(--form-error-red);
	}

	.line-divider {
		background-color: var(--color);
		width: 100%;
		height: 1px;
	}

	.g-col {
		padding-top: rs(12, 12);
	}

	input,
	textarea {
		border: none;
		width: 100%;
		padding: 0;
		resize: none;
		outline: none;
		box-shadow: none;

		&::placeholder {
			color: var(--color);
			opacity: 0.4;
		}
	}
}
</style>
